import { PeopleAndTeamsConfigurationProvider } from '@atlassian/people-teams-configuration-client';
import { LoadableAfterPaint } from '@confluence/loadable';

import { ModalTransition } from '@atlaskit/modal-dialog';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import React, { Suspense, useCallback } from 'react';
import type { FlagDescriptor } from '@confluence/flags/entry-points/FlagsStateContainer';
import type { Flag } from '@atlassian/people-teams';

const LazyTeamCreateDialog = LoadableAfterPaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-TeamAppShortcutItemCreateTeamDialog" */ '@atlassian/people-teams'
		).then(({ TeamCreateDialog }) => TeamCreateDialog),
	loading: () => null,
});

type CreateTeamModalProps = {
	isOpen: boolean;
	onClose: () => void;
	addFlag: (flag: FlagDescriptor) => void;
};
export function CreateTeamModal({ isOpen, onClose, addFlag }: CreateTeamModalProps) {
	const { cloudId, orgId } = useSessionData();

	const addFlagFn = useCallback(
		(flag: Flag) => {
			const { title, description, appearance, actions } = flag;
			addFlag({
				type: appearance === 'success' || appearance === 'normal' ? 'success-circle' : appearance,
				title,
				description,
				close: 'auto',
				actions,
				id: flag.id,
			});
		},
		[addFlag],
	);

	return (
		<ModalTransition>
			{isOpen ? (
				<Suspense>
					<PeopleAndTeamsConfigurationProvider product="confluence">
						<LazyTeamCreateDialog
							cloudId={cloudId}
							product="confluence"
							orgId={orgId}
							onClose={onClose}
							enableMembershipSettingsChoice
							enableTeamPermissionCheck
							onCreateTeamSuccess={onClose}
							onCreateTeamFailed={onClose}
							addFlag={addFlagFn}
						/>
					</PeopleAndTeamsConfigurationProvider>
				</Suspense>
			) : null}
		</ModalTransition>
	);
}
